import { axiosInstance, BASE_URLS } from "@/src/shared/api";

interface ContactUsForm {
  orderNumber: string;
  clientTheme: string;
  clientName: string;
  clientPhone: string;
  clientEmail: string;
  clientText: string;
  personalDataAgreement: boolean;
  attachments: File[];
}

export const sendContactUsForm = async ({
  attachments,
  ...payload
}: ContactUsForm): Promise<boolean> => {
  try {
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      formData.append(key, value as string);
    });
    attachments?.forEach((file) => {
      formData.append("attachments", file);
    });

    const response = await axiosInstance.post(
      `${BASE_URLS.CONTACT_US}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return response.data;
  } catch (error: any) {
    console.error(
      "error",
      "[sendContactUsForm] Error while sending contact us form",
      {
        url: error?.config?.url,
        meta: error?.response?.data,
      },
    );
    throw error;
  }
};
